/**
 * JS that should be imported on every page. Should be migrated to web/common/frontend at some point.
 *
 * Try to keep this code login-page-agnostic if we can.
 */

// eslint-disable-next-line
import $ from 'jquery'; // This is exposed to the global context thanks to expose-loader.
import '@zr/common/js/common/base';

import '@zr/common/js/initScriptSrcLoadError';

import './log_page_view';

import '@zr/common/js/skip_to_content';

$(document).ready(() => $('body').addClass('selenium_ready'));

$(document).ready(() => {
  setTimeout(() => { $('body').removeClass('doc_loading'); }, 0);
});
